import { LoadingStatusType } from "@/enums/enums";
import API from "@/service/Index";

import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class PrivateFile extends VuexModule {
  public privateFile: any = [];
  public privateFileLoadingStatus: LoadingStatusType = LoadingStatusType.None;

  get getPrivateFile(): any {
    return this.privateFile;
  }
  get getPrivateFileLoadingStatusLoadingStatus(): LoadingStatusType {
    return this.privateFileLoadingStatus;
  }

  @Mutation
  public MutationSetPrivateFile(privateFile: any) {
    this.privateFile = privateFile;
  }

  @Mutation
  public MutationSetPrivateFileLoadingStatus(status: LoadingStatusType) {
    this.privateFileLoadingStatus = status;
  }

  @Action
  public DoGetPrivateFile(_input: any) {
    this.context.commit("MutationSetPrivateFileLoadingStatus", LoadingStatusType.Loading);
    API.PrivateFileService.DoGenerateSASToken(_input).then((res) => {
      if (res.length > 0) {
        this.context.commit("MutationSetPrivateFile", res);
        this.context.commit("MutationSetPrivateFileLoadingStatus", LoadingStatusType.Success);
      }
    });
  }
}
